import { Button } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

import { DomainType } from '@verantos-dev/types-cohorts';

export interface CustomizeButtonProps {
  domain: DomainType;
  onClick: () => void;
  disabled?: boolean;
}

export const CustomizeButton: React.FC<CustomizeButtonProps> = ({
  domain,
  onClick,
  disabled = false,
}) => {
  const intl = useIntl();

  const getDomainDisplayName = (domainType: DomainType): string => {
    const domainMap: Record<string, string> = {
      ccCondition: intl.formatMessage({
        id: 'projects.cohortBuilder.cohortCharacteristics.domain.conditions',
      }),
      ccDrug: intl.formatMessage({
        id: 'projects.cohortBuilder.cohortCharacteristics.domain.drugs',
      }),
      ccMeasurement: intl.formatMessage({
        id: 'projects.cohortBuilder.cohortCharacteristics.domain.measurements',
      }),
      ccObservation: intl.formatMessage({
        id: 'projects.cohortBuilder.cohortCharacteristics.domain.observations',
      }),
      ccProcedure: intl.formatMessage({
        id: 'projects.cohortBuilder.cohortCharacteristics.domain.procedures',
      }),
      ccVisit: intl.formatMessage({
        id: 'projects.cohortBuilder.cohortCharacteristics.domain.visits',
      }),
    };

    return domainMap[domainType] || 'items';
  };

  const handleClick = () => {
    onClick();
  };

  return (
    <Button
      variant="outlined"
      onClick={handleClick}
      disabled={disabled}
      sx={{
        textTransform: 'none',
        borderRadius: 1,
        px: 3,
        height: 40,
        // Keep the label on one line and the button at its natural width
        // when the controls row wraps — otherwise a squeezed flex row
        // wraps the label to two lines and crushes the button.
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      {intl.formatMessage(
        { id: 'projects.cohortBuilder.cohortCharacteristics.customizeButton.label' },
        { domain: getDomainDisplayName(domain) }
      )}
    </Button>
  );
};
